export default "/assets/images/hey-google.a59f080708aea61b.png";